import { z } from "zod"

export const telemetryEvent = z.object({
    longitude: z.number(), // degrees
    latitude: z.number(), // degrees
    height: z.number(), // metres above mean sea level
    elevation: z.number().optional(), // metres above take-off point
    yaw: z.number(), // degrees
    pitch: z.number(), // degrees
    roll: z.number(), // degrees
    timestamp: z.number(), // unix time in milliseconds
    fov: z.union([z.array(z.number()), z.number()]).optional(), // [horizontal, vertical] degrees; omitted when not available
    horizontalSpeed: z.number().optional(), // m/s
    verticalSpeed: z.number().optional(), // m/s
    windSpeed: z.number().optional(), // m/s
})

export type TelemetryEvent = z.infer<typeof telemetryEvent>
